export const REVIEW_STATUS = {
  PUBLISHED: "PUBLISHED",
  BANNED: "BANNED",
};
